import React from "react";
import styled from "styled-components/macro";

const labels = { not_started: "Not started", in_progress: "In progress", done: "Done" };

const Marker = styled.span`
  display: inline-flex;
  align-items: center;
  /* The onboarding prototype's 6px between the dot and its word */
  gap: calc(var(--juno-space-1) + var(--juno-space-half));
`;

const Dot = styled.span`
  width: var(--juno-space-2);
  height: var(--juno-space-2);
  flex-shrink: 0;
  border-radius: 50%;
  background-color: var(--status-done);

  &[data-status="in_progress"] {
    background-color: var(--status-in-progress);
  }
`;

// A row's status in Things to do and on a request group collection's page. The word carries the status, so
// the dot is hidden from assistive technology; a request not started has no dot.
const StatusMarker = ({ status }) => (
  <Marker>
    {status !== "not_started" && <Dot data-status={status} aria-hidden />}
    {labels[status]}
  </Marker>
);

export default StatusMarker;
